import { render, staticRenderFns } from "./ActiveEconomyIntegration.vue?vue&type=template&id=0bf2e70a&scoped=true&"
import script from "./ActiveEconomyIntegration.vue?vue&type=script&lang=js&"
export * from "./ActiveEconomyIntegration.vue?vue&type=script&lang=js&"
import style0 from "./ActiveEconomyIntegration.vue?vue&type=style&index=0&id=0bf2e70a&lang=scss&scoped=true&"
import style1 from "./ActiveEconomyIntegration.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2e70a",
  null
  
)

export default component.exports